module.exports = __webpack_public_path__ + "static/media/marker_bubble_drag_selected.fb4813ca.svg";